// @flow

import {createErrorHandler, get, patchJson, postJson} from 'app/utils/request';
import {REVIEW_API_URL} from 'app/urls';

import {type ReviewType} from 'app/review/types';
import {gt} from 'app/utils/i18n';
import {showNotification} from 'app/toasts/slice';
import {limitRequests} from 'app/utils/redux';

export const RECEIVE_OBJECT_REVIEW = 'RECEIVE_OBJECT_REVIEW';
export const REQUEST_REVIEW = 'REQUEST_REVIEW';
export const requestReview = () => ({
  type: REQUEST_REVIEW,
});
export const receiveObjectReviews = (
  objectId: number,
  contentType: 'policy' | 'procedure' | 'proceduregroup',
  data: Array<ReviewType>
) => ({
  type: RECEIVE_OBJECT_REVIEW,
  data,
  objectId,
  contentType,
});

export const getObjectReviews = limitRequests(
  (
      objectId: number,
      contentType: 'policy' | 'procedure' | 'proceduregroup',
      loadNextPage: boolean = false
    ) =>
    (dispatch: SimpleDispatch, getState: any) => {
      dispatch(requestReview);

      const pageToFetch =
        loadNextPage === false
          ? 1
          : getState().reviews.getIn(
              ['objects', contentType, objectId.toString(), 'next'],
              1
            );

      return get(REVIEW_API_URL, {
        content_type: contentType,
        object_id: objectId,
        page: pageToFetch,
      }).then(
        (data) => dispatch(receiveObjectReviews(objectId, contentType, data)),
        createErrorHandler("Couldn't fetch document review", dispatch)
      );
    }
);

export const markAsReviewed =
  (
    versionId: number,
    versionContentType: 'policyversion' | 'procedureversion' | 'processversion'
  ) =>
  (dispatch: FuncDispatch) => {
    dispatch(requestReview);
    return postJson(REVIEW_API_URL, {
      version_id: versionId,
      version_content_type: versionContentType,
    }).then((data) => {
      dispatch(showNotification(gt('Document marked as reviewed')));
      dispatch(getObjectReviews(data.object_id, data.content_type, false));
      return data;
    }, createErrorHandler("Couldn't review document", dispatch));
  };

export const setNextReviewAt =
  (
    documentURL: string,
    next_review_at: string | null,
    review_period_months: number | null,
    reviewer: string | null
  ) =>
  () =>
    patchJson(documentURL, {next_review_at, review_period_months, reviewer});
